function processText(text, context) {
  // TODO(#26708): drop this guard once #26707 lands and the decision-tree
  // API contract guarantees non-null text input
  if (!text) {
    return text ?? "";
  }
  text = text.replaceAll(
    /\|PATIENT-TYPE(?::(.*?))?\|/g,
    (match, defaultValue) => context.patientType || defaultValue || "this patient's type",
  );
  text = text.replaceAll(
    /\|PROVIDER-NAME(?::(.*?))?\|/g,
    (match, defaultValue) => context.providerName || defaultValue || "this provider",
  );
  text = text.replaceAll(
    /\|PROVIDER-PHONE-NUMBER(?::(.*?))?\|/g,
    (match, defaultValue) => telLink(context.providerPhoneNumber) || defaultValue || "this provider's number",
  );
  text = text.replaceAll(/(?:(\b[Aa])\s+)?\|PROVIDER-TYPE(?::(.*?))?\|/g, (match, article, defaultValue) => {
    const replacement = context.providerType || defaultValue || "this provider's type";
    // Ensure correct use of "a" vs "an"
    if (article) {
      const isVowel = /^[aeiou]/i.test(replacement);
      if (isVowel) {
        return `${article}n ${replacement}`;
      }
      return `${article} ${replacement}`;
    }
    return replacement;
  });
  text = text.replaceAll(
    /\|PROVIDER-TYPE-DESCRIPTION(?::(.*?))?\|/g,
    (match, defaultValue) => context.providerTypeDescription || defaultValue || "a description of this provider's type",
  );
  text = text.replaceAll(
    /\|PROVIDER-LICENSED-STATES(?::(.*?))?\|/g,
    (match, defaultValue) =>
      arrayToUL(context.providerLicensedStateNames) || defaultValue || "this provider's licensed states",
  );
  text = text.replaceAll(
    /\|SELECTED-STATE(?::(.*?))?\|/g,
    (match, defaultValue) => context.selectedStateName || defaultValue || "the selected state",
  );
  text = text.replaceAll(
    /\|SELECTED-VISIT-TYPE(?::(.*?))?\|/g,
    (match, defaultValue) => context.visitType?.name || defaultValue || "selected visit type",
  );
  text = text.replaceAll(
    "LICENSED-PROVIDER-SEARCH-URL",
    context.licensedProviderSearchUrl?.replace("SELECTED-STATE-NAME", context.selectedStateName) || "",
  );

  return text;
}

function telLink(phoneNumber) {
  if (!phoneNumber) {
    return;
  }

  return `<a href="tel:${phoneNumber}">${phoneNumber}</a>`;
}

function arrayToUL(array) {
  if (!array) {
    return;
  }

  return `<ul>${array.map((element) => `<li>${element}</li>`).join("")}</ul>`;
}

export function useSnippetProcessor() {
  return {
    processText,
  };
}
